<template>
    
    
        <Teleport to="body">
            <Transition name="bounce">
                <div v-if="modelValue" class="main">
        
                    <div ref="target" class="pop">            
                        
                        <!-- close -->
                        <svg style="position: absolute; top: 10px;right: 10px; cursor: default;" @click="close()" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle class="pointer" cx="6" cy="6" r="6" fill="var(--g1)"/></svg>
                        
                        
                        <div class="column center" style="justify-content: space-between;">  
                            <div class="column center">     
                                <img v-if="icon" :src="`/images/popup/${icon}.svg`" style="margin: 20px 0 10px;">                           
                                <p v-if="$slots.title || title" class="title">{{ title }}<slot name="title"></slot></p>                                
                                <p v-if="$slots.sub || sub" class="sub">{{ sub }}<slot name="sub"></slot></p>                                
                            </div>
                            <div class="body"><slot></slot></div>
                            <div class="row"><slot name="bottom"></slot></div>
                        </div>            
                    </div>
                </div>
        

    </Transition>
</Teleport>
    
<!--         
    
    <Popup v-model="db.settings.login">
        <template #icon><svg/></svg></template>
        <template #title>{{$t('title.welcome')}}</template>
        <template #line>{{$t('line.welcome')}}</template>
        <template #desc>{{$t('desc.welcome') }}</template>  
        <Login @done="db.settings.login = false"/>      
    </Popup>        

-->
     
</template>
<script>
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';
export default {
    setup(props, { emit }) {
        const target = ref(null)
        onClickOutside(target, (event) => emit('update:modelValue', false))
        return { target}
    },
    data: function () {
        return {}},
    props:{
        modelValue: Boolean,        
        
        title:String,
        sub:String,        
        icon:String,        
    },
    methods: {
        close(){
            this.$emit('update:modelValue', false);
        },
    },

    filters: {
    checkEmpty(value) {
      return typeof value !== "number" ? 0 : value;
    }
  },
}
</script>

<style scoped>

.main{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    flex-direction: column;
    position: fixed; 
    z-index: 1; 
    width: 100vw; 
    height: 100vh; 
    top: 0;
    left: 0;
    padding: none,    
}

   .pop {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background: var(--popupBack);       
        border-radius: var(--popupBorder);    
        position: absolute;  
        z-index: 10000000;                
        box-shadow: var(--popupShadow);
        max-height: 90vh;
        overflow-y: scroll;
        padding: 10px 30px 20px;
   }

   .icon{
    /* margin: 10px 0 10px;     */
   }

   .topicon{
    /* position: absolute; */
    margin-top: 20px;
    /* top:10px; */
    z-index: 1000;
   }
   .title{
        font-family: var(--titleFonts);
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 60%;
        text-align: center;
        letter-spacing: 5%;
        color: var(--title);        
        margin-bottom: 12px;
        text-transform: uppercase;
        margin-top: 8px;
   }

   .sub { 
    letter-spacing: 5%;     
    font-size: 9px; 
    font-weight: 500; 
    text-transform: uppercase; 
    color: var(--g4); 
    line-height: 14px; 
    margin: 0 0 6px; 
}

   .desc{
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 140%;
        text-align: center;
        color: var(--g3);
        margin-top: 4px;
        letter-spacing: 0.02em;
   }
   .upperTitle{
        font-family: var(--titleFonts);
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 140%;
        text-align: center;
        color: var(--g3);
        /* margin-top: 4px; */
        letter-spacing: 0.02em;
        margin-bottom: 10px;
        text-transform: uppercase;
   }
   
   .headspace{
    display: flex;
       flex-direction: column;
       justify-content: center;
    width:100%; 
    padding: 10px 0;
    user-select: none;
   }
   .nopadding{
    padding:0
   }
   .wrapper{
       position: relative;
       display: flex;
       flex-direction: column;
       /* justify-content: space-between; */
       align-items: flex-start;
       height: 100%;
       width: 100%;
   }


    .body{
        position: relative;
       display: flex;
       flex-direction: column;
       width: 100%;
       padding: 0px 0px;
   }

    .close{
      cursor: default;
      transition: all 0.1s ease;
    }
    
    .close:hover{
      fill-opacity: 0.16;
    }

    .scroll{
        overflow-y: scroll;
    }

</style>